import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import helpers from "helpers/index";
import queryClient, { IQueryParams } from 'queries';

export interface TypedTrip_manifest_fee {
    id?: string;
    trip_manifest_id?: string;
    trip_fee?: number;
    trip_fee_description?: string;
    createdAt?: string;
    createdBy?: string;
}

type IQuery = TypedTrip_manifest_fee & IQueryParams;


/*
* List of all trip manifest
*/
export function useGetTrip_manifest_fees(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["trip_manifest_fee/fetch_entity_list", object],
        queryFn: () => axios.get<TypedTrip_manifest_fee[]>(`/trip_manifest_fee/${EndURL}`).then(response => response.data),
        retry: 1,
        enabled: !!object.trip_manifest_id,
    });
}

export function useMutateAdd_fee_to_trip() {
    return useMutation({
        mutationKey: ['trip_manifest_fee/create_entity'],
        mutationFn: (body: {
            trip_manifest_id: string | bigint;
            trip_fee: number;
            trip_fee_description: string;
        }) => axios.post(`/trip_manifest_fee`, body).then((response) => response.data),
        onSuccess: () => {
            /** Load lại trip */
            // queryClient.invalidateQueries({ queryKey: ['trip_manifest_fee/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
        }
    });
}

/** Xóa tài xế đi  */
export function useMutateRemove_fee_from_trip() {
    return useMutation({
        mutationKey: ['trip_manifest_fee/delete_entity'],
        mutationFn: (trip_manifest_fee_id: string) => axios.delete<any>(`/trip_manifest_fee/${trip_manifest_fee_id}`).then(response => response.data),
        onSuccess: () => {
            // queryClient.invalidateQueries({ queryKey: ['trip_manifest_fee/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
        }
    });
}
